module.exports = __webpack_public_path__ + "assets/img/reseller.0bf898e7.svg";